import { BasicButton } from './BasicButton';
import { BasicText } from './BasicText';

// types
//-----------------------------------------------------------------------------
export type BasicTabButtonOptions = {
  text: string;
  width: number;
  height: number;
};

// constants
//-----------------------------------------------------------------------------
const manifest = {
  up: 'assets/ui/match2/editor/buttons/button.blockmenu.png',
  selected: 'assets/ui/match2/editor/buttons/button.blockmenu.selected.png',
};

/*
    button for tab menu
*/
export class BasicTabButton extends BasicButton {
  // private
  //-------------------------------------------------------------------------
  private _text!: BasicText;

  // init
  //-------------------------------------------------------------------------
  constructor(options: BasicTabButtonOptions) {
    super({
      width: options.width,
      height: options.height,
      up: manifest.up,
      selected: manifest.selected,
      contentAnchor: {
        x: 0.5,
        y: 1,
      },
    });

    this.width = options.width;
    this.height = options.height;

    // spawn text
    this._spawnText(options);

    // update based on initial state
    this._updateTextStyle();
  }

  public static assets(): string[] {
    return Object.values(manifest);
  }

  // impl
  //-------------------------------------------------------------------------
  protected override onBaseSelected(value: boolean): void {
    super.onBaseSelected(value);

    // update text style
    this._updateTextStyle();
  }

  // private: scene
  //-------------------------------------------------------------------------
  public _spawnText(options: BasicTabButtonOptions) {
    // create
    const text = (this._text = new BasicText({
      text: options.text,
    }));
    text.width = this.width;
    text.height = this.height;
    text.anchorY = 0.5;
    text.x = 5;
    text.y = this.height / 2 + 5;
    this.content.addChild(text);
  }

  // private: updaters
  //-------------------------------------------------------------------------
  private async _updateTextStyle() {
    const scale = super.selected ? 1.2 : 1;
    this._text.scaleX = scale;
    this._text.scaleY = scale;
  }
}
